import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { PagingRequest } from "./../../../../models/domains/paginator/paging-request";
import { RoutePath } from "./../../../../models/domains/route-paths.model";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { SalesHistoryService } from "src/app/ui/services/pbm/sales-history.service";
import { LoadingService } from "src/app/ui/services/loading.service";
import { FilterBy } from "src/app/ui/models/domains/pbm/sales-history/filter-by";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { Toast } from "../../../toast/toast";
import { UserService } from "src/app/ui/services/user.service";
import { UntypedFormControl } from "@angular/forms";
import { FiscalNumber } from "src/app/ui/models/domains/pbm/fiscal-number";

@Component({
  selector: "sales-history-companies",
  templateUrl: "./sales-history-companies.component.html",
  styleUrls: ["./sales-history-companies.component.scss"],
})
export class SalesHistoryCompaniesComponent implements OnInit {
  pageableResult: PageableResult = new PageableResult();
  filterBy = FilterBy;
  fiscalNumberMask = MaskInput.getFicalNumberMask();
  filterText: string = "";
  messageResult = new MessageResult();
  searchType: UntypedFormControl;
  totalPerPage = 10;
  showLoadMore = true;

  constructor(
    private featureViewService: FeatureViewService,
    private router: Router,
    private salesHistoryService: SalesHistoryService,
    private loadingService: LoadingService,
    private toast: Toast,
    private userService: UserService,
  ) {
    this.searchType = new UntypedFormControl(1);
  }

  async ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.SalesHistoryCompanies, PageViews.SalesHistoriesPageView);
    const userProfile = this.userService.getUserProfile();
    if (userProfile.getPreferences().getFilterText()) {
      this.detailSalesHistory(userProfile.getPreferences().getFilterText());
    }
    const ref = this.loadingService.beginLoading();
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(1);
    pagingRequest.setEnd(this.totalPerPage);
    pagingRequest.setFilterText("Last7Days");
    try {
      this.pageableResult = await this.salesHistoryService.findSalesHistory("", pagingRequest);
      if (this.salesHistoryList().length === 0) {
        this.messageResult.setMessage("Nenhum resultado encontrado.");
        this.showLoadMore = false;
      } else {
        this.messageResult.setMessage("");
      }
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  onPressEnterSearchCompanies(event): void {
    if (event.key === "Enter") {
      this.onSearchCompany(this.filterText);
    }
  }

  async searchMoreSalesHistories() {
    const ref = this.loadingService.beginLoading();

    const filter = document.getElementById("filter") as HTMLSelectElement;

    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(this.pageableResult.getEnd());
    pagingRequest.setEnd(this.totalPerPage);
    pagingRequest.setFilterText(filter.value);

    try {
      const result = await this.salesHistoryService.findSalesHistory("", pagingRequest);
      this.pageableResult.setStart(result.getStart());
      this.pageableResult.setEnd(this.totalPerPage + 1);
      this.pageableResult.addItems(result.getItems());
      if (result.getItems().length < this.totalPerPage) {
        this.showLoadMore = false;
      }
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  async onSearchCompany(filterText: string) {
    const ref = this.loadingService.beginLoading();
    const filter = document.getElementById("filter") as HTMLSelectElement;
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(1);
    pagingRequest.setEnd(this.totalPerPage);
    pagingRequest.setFilterText(filter.value);
    try {
      this.pageableResult = await this.salesHistoryService.findSalesHistory(filterText.replace(/[./-]/g, ""), pagingRequest);
      if (this.salesHistoryList().length === 0) {
        this.messageResult.setMessage("Nenhum resultado encontrado.");
        this.showLoadMore = false;
      } else {
        this.messageResult.setMessage("");
      }
      this.storageSearchPreferences(filterText);
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  salesHistoryList() {
    return this.pageableResult.getItems();
  }

  detailSalesHistory(filterText: string): void {
    if (FiscalNumber.isValid(filterText)) {
      this.router.navigate([RoutePath.SalesHistoryCompany], {
        queryParams: { b: filterText },
      });
    }
  }

  storageSearchPreferences(filterText: string): void {
    this.userService.setUserPreferences(filterText.replace(/[./-]/g, ""));
  }
}

class MessageResult {
  private message: string;

  constructor() {
    this.message = "";
  }

  setMessage(value: string): void {
    this.message = value;
  }

  getMessage(): string {
    return this.message;
  }
}
